import { createPOBoxIfNeeded } from 'api/POBoxApi';
import LoadingScreen from 'components/LoadingScreen';
import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { USER_GROUPS } from 'utils/Constants';
import { getUserData, getUserGroups, isLogin } from '../../utils/Session';

const DashboardRoute = () => {
    const [isUserLoggedIn, setLoginState] = useState();
    const [userDashboardUrl, setUserDashboardUrl] = useState();
    useEffect(async () => {
        const isLoggedIn = await isLogin();
        setLoginState(isLoggedIn);

        const userGroup = await getUserGroups();
        if (userGroup.includes(USER_GROUPS.ADMIN)) {
            setUserDashboardUrl('/admin/home')
        } else {
            const userData = await getUserData();
            await createPOBoxIfNeeded(userData);
            setUserDashboardUrl('/user/dashboard')
        }

    }, []);

    return !isUserLoggedIn || (isUserLoggedIn && !userDashboardUrl) ? <LoadingScreen isLoading={true} /> : isUserLoggedIn ? <Navigate to={userDashboardUrl} /> : <Navigate to="/auth/login" />;

};

export default DashboardRoute;